import { clickoutUrl } from '~/components/deal/clickout-url'
import { useAppContext } from '~/contexts/app-context'
import { usePageContext } from '~/contexts/page-context'
import { isProd } from '~/server/helpers/env'

const DEAL_ID = 374249

const REDIRECT_LINK = encodeURIComponent(
  'https://www.awin1.com/awclick.php?gid=465412&mid=6399&awinaffid=100908&linkid=3394372&clickref={{click_ref}}'
)
const STAGING_LINK = `https://ldn-staging.internal.usw.co./clk/${DEAL_ID}/uswitch/broadband?r=${REDIRECT_LINK}&sig=dd0c00c809e53cf90fb595b2640d8f30a89a542a8d0ff0d7dbb3385b72c35882`
const PRODUCTION_LINK = `https://www.uswitch.com/clk/${DEAL_ID}/uswitch/broadband?r=${REDIRECT_LINK}&sig=dd0c00c809e53cf90fb595b2640d8f30a89a542a8d0ff0d7dbb3385b72c35882`

export interface TrackingArgs {
  comparisonId: string
  postcode: string
  sort: string
}

interface Args extends TrackingArgs {
  title: string
}

export const useVirginMediaBannerLink = ({ comparisonId, postcode, sort, title }: Args) => {
  const { cookies, device } = useAppContext()
  const { listnames, pageId, path } = usePageContext()

  const url = isProd ? PRODUCTION_LINK : STAGING_LINK

  return clickoutUrl({
    pageId,
    page: path,
    deal: {
      id: DEAL_ID,
      productId: 12466195,
      provider: { name: 'Virgin Media' },
      clickoutLinks: [{ type: 'CLICKOUT', url }]
    },
    ecommerce: { comparisonId, impressionId: `${comparisonId}-${DEAL_ID}` },
    list: listnames().table,
    currentProvider: 'Virgin Media',
    postcode,
    placementType: 'table',
    sort,
    device,
    sskey: cookies.sskey,
    title
  })
}
